import React, { FC } from "react";
import { ContentManager } from "../content-manager";
import { Image } from "../image";
import NextImage from "next/image";
import type { OriginatingInstitutionsHeroProps } from "@/types";
import { TextCols } from "../text-cols";
import { ContactModal } from "../contact-modal";

export const OriginatingInstitutionsHero: FC<OriginatingInstitutionsHeroProps> = ({
  label,
  title,
  description,
  cover,
  cta,
  contactModal,
}) => {
  const [showContactModal, setShowContactModal] = React.useState(false);

  React.useEffect(() => {
    if (showContactModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showContactModal]);

  return (
    <section className="originatingInstitutionsHero">
      <div className="wrapper">
        <TextCols
          headingLevel="h1"
          size="lg"
          label={label}
          content={{
            title,
            textCol1: description.textCol1,
            textCol2: description.textCol2,
          }}
          maxTitleWidth={883}
        />
      </div>
      <div className="wrapper wrapper_lg">
        {cover.file?.url && (
          <Image
            loading="eager"
            fetchPriority="high"
            className="originatingInstitutionsHero--cover"
            src={cover as any}
            alt={cover.title}
            animateInView
          />
        )}
        {/* TODO: Temporary hidden */}
        <div className="cta originatingInstitutionsHero--cta">
          <div className="cta--inner">
            {cta.text && (
              <ContentManager content={cta.text} className="cta--text" />
            )}
            <button
              className="link link_white link_full cta--link"
              onClick={() => {
                setShowContactModal(true);
              }}
              data-title={cta.buttonLabel}
            >
              <span>{cta.buttonLabel}</span>
            </button>
          </div>
          <NextImage
            src="/images/spiral-2.webp"
            alt="Spiral"
            width={1417}
            height={1653}
            role="presentation"
            draggable={false}
            className="cta--spiral"
          />
        </div>
      </div>
      {showContactModal && (
        <ContactModal
          {...contactModal}
          onClose={() => {
            setShowContactModal(false);
          }}
        />
      )}
    </section>
  );
};
